const evaluate = (x, v, tension, friction, dt, ddx, ddv) => {
    if (dt && ddx && ddv) {
        x = x + ddx * dt;
        v = v + ddv * dt;
    }
    const dx = v;
    const dv = -tension * x - friction * v;
    return [dx, dv];
};

const integrate = (x, v, tension, friction, speed) => {
    const [adx, adv] = evaluate(x, v, tension, friction);
    const [bdx, bdv] = evaluate(x, v, tension, friction, speed * 0.5, adx, adv);
    const [cdx, cdv] = evaluate(x, v, tension, friction, speed * 0.5, bdx, bdv);
    const [ddx, ddv] = evaluate(x, v, tension, friction, speed, cdx, cdv);
    const dxdt = (1.0 / 6.0) * (adx + 2.0 * (bdx + cdx) + ddx);
    const dvdt = (1.0 / 6.0) * (adv + 2.0 * (bdv + cdv) + ddv);
    return [x + dxdt * speed, v + dvdt * speed];
};

const SPEED = 1 / 60.0;
const TOLERANCE = 0.01;
const START = 0;
const END = 100;

export const createSpring = (options = {}) => {
    const tension = options.tension || 80;
    const friction = options.friction || 8;
    let velocity = options.velocity || 0;

    let current = START;
    let moving = false;

    const isMoving = () => moving;

    const reset = () => {
        current = START;
        moving = true;
    };

    const step = () => {
        const [x, v] = integrate(
            current - END,
            velocity,
            tension,
            friction,
            SPEED
        );

        moving = Math.abs(v) > TOLERANCE;

        if (moving) {
            velocity = v;
            current = END + x;
        } else {
            velocity = 0;
            current = END;
        }

        return current;
    };

    reset();

    return {
        reset,
        step,
        isMoving
    };
};
